import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Link as MaterialLink,
  Snackbar,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { Link, Redirect, withRouter, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  MobileAlert,
  MobileRegularPage,
  MobileTextField,
  repliValidator,
} from "../../../components";
import MobileLoading from "../../../components/MobileLoading";
import { checkSignedIn } from "../../../services/auth.service";
import useStyles from "./SignIn.style";
import logo from "../../../images/logo_full.png";
import { AppButton, ReverseAppButton } from "../components/InputComponents";
import CryptoJS from "crypto-js";
import YesNoDialog from "../../../components/YesNoDialog";
import Cookies from "universal-cookie";

const SignInTextField = (props) => {
  return <MobileTextField color="secondary" fullWidth {...props} />;
};

const SignIn = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [is2fauthentication, set2fauthentication] = useState(false);
  const [dailogueText, setDailogueText] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const cookies = new Cookies();
  const validator = useRef(repliValidator());

  useEffect(() => {
    const isSignedIn = async () => {
      let result = await checkSignedIn();
      setAuthenticated(result);
      setLoading(false);
    };
    isSignedIn();
  }, []);

  useEffect(() => {
    const storedEmail = cookies.get("email");
    const storedPassword = cookies.get("password");
    const storedRememberMe = cookies.get("rememberMe")

    if (storedEmail && storedPassword && storedRememberMe) {
      setEmail(
        CryptoJS.AES.decrypt(
          storedEmail,
          process.env.REACT_APP_SECRET_KEY
        ).toString(CryptoJS.enc.Utf8)
      );
      setPassword(
        CryptoJS.AES.decrypt(
          storedPassword,
          process.env.REACT_APP_SECRET_KEY
        ).toString(CryptoJS.enc.Utf8)
      );
      setRememberMe(storedRememberMe); 
    }

  }, []);

  const handleDialogAnswer = (answer) => async (e) => {
    setOpenDialog(false);
    if (answer !== "yes") return;
    try {
      let response = await fetch(
        `${process.env.REACT_APP_API_URL}/${"api/auth/app/signinpatient"}`,
        {
          method: "post",
          body: new URLSearchParams({
            email: email,
            password: password,
          }),
        }
      );
      if (!response.ok) {
        let json = await response.json();

        setError(json.message || json.errors[0].msg);
        return;
      }

      let json = await response.json();
      set2fauthentication(json.is2FAEnabled);

      const encryptEmail = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(json.email),
        process.env.REACT_APP_SECRET_KEY
      );

      localStorage.setItem("email", encryptEmail);

      localStorage.setItem("is2FAEnabled", json.is2FAEnabled);

      localStorage.setItem("isProvider", json.isProvider);

      localStorage.setItem("isPatientSignIn", "true");

      setAuthenticated(true);
    } catch (error) {
      console.log(error.message);
      setError(t("signIn.errorMessage"));
    } finally {
      setSending(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    const isValid = validator.current.allValid();
    if (!isValid) {
      validator.current.showMessages();
      return;
    }

    setSending(true);
    try {
      let response = await fetch(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH_SIGNIN}`,
        {
          method: "post",
          body: new URLSearchParams({
            email: email,
            password: password,
          }),
        }
      );
      if (!response.ok) {
        let json = await response.json();
        setError(json.message || json.errors[0].msg);

        if (json.message == "Your Organization is not active") {
          setDailogueText(`Your organization is not active.
          Do you want to login as an Individual user ?`);
          location.pathname === "/app/signin"
            ? setOpenDialog(true)
            : setOpenDialog(false);
        } else if (json.message == "You don't have any organizations") {
          setDailogueText(`You don't have any organizations.
          Do you want to login as an Individual user ?`);
          location.pathname === "/app/signin"
            ? setOpenDialog(true)
            : setOpenDialog(false);
        }
        return;
      }

      let json = await response.json();
      set2fauthentication(json.is2FAEnabled);

      const encryptEmail = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(json.email),
        process.env.REACT_APP_SECRET_KEY
      ).toString();

      const encryptPassword = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(password),
        process.env.REACT_APP_SECRET_KEY
      ).toString();

      if (rememberMe) {
        cookies.set("email", encryptEmail, { path: "/"});
        cookies.set("password", encryptPassword, { path: "/"});
        cookies.set("rememberMe", rememberMe, { path: "/"});
       
      } else {
        cookies.remove("email", { path: "/"});
        cookies.remove("password", { path: "/"});
        cookies.remove("rememberMe", { path: "/"});
        
      }

      localStorage.setItem("email", encryptEmail);

      localStorage.setItem("is2FAEnabled", json.is2FAEnabled);

      localStorage.setItem("isProvider", json.isProvider);

      localStorage.setItem("isPatientSignIn", "true");

      setAuthenticated(true);
    } catch (error) {
      console.log(error.message);
      setError(t("signIn.errorMessage"));
    } finally {
      setSending(false);
    }
  };

  const handleMessageClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setError("");
  };

  // if (loading) return <MobileLoading />;

  if (!is2fauthentication && isAuthenticated)
    return <Redirect to="/app/authentication"></Redirect>;

  if (is2fauthentication && isAuthenticated)
    return <Redirect to="/app/otpverification"></Redirect>;

  return (
    <MobileRegularPage>
      <Box className={classes.logoSection}>
        <img src={logo} alt="logo" />
      </Box>
      <form className={classes.form} onSubmit={handleSubmit}>
        <Box style={{textAlign:'left'}}>
          <SignInTextField
            label={`Username/${t("common.form.label.email")}*`}
            error={submitted && !validator.current.fieldValid("email")}
            helperText={validator.current.message("email", email, "required")}
            onChange={(e) => setEmail(e.target.value.trim())}
            value={email}
          />
          <SignInTextField
            label={`${t("signIn.inputPlaceholders.password")}*`}
            error={submitted && !validator.current.fieldValid("password")}
            helperText={validator.current.message(
              "password",
              password,
              "required|min:8"
            )}
            type="password"
            onChange={(e) => setPassword(e.target.value.trim())}
            value={password}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                color="secondary"
              />
            }
            label={t("common.form.label.rememberMe")} // Add a translation key for the checkbox label
          />
        </Box>
        <Grid container className={classes.linkContainer}>
          <Grid item>
            <MaterialLink component={Link} to="/app/signin/pwdrecovery">
              {t("signIn.links.forgotPassword")}
            </MaterialLink>
          </Grid>
          <Grid item>
            <MaterialLink component={Link} to="/app/signup">
              {t("signIn.links.signUp")}
            </MaterialLink>
          </Grid>
          {/*                     <Grid item>
                        <MaterialLink component={Link} to="/app/tokenresend">
                            {t('signIn.links.tokenResend')}
                        </MaterialLink>
                    </Grid> */}
        </Grid>
        <Box className={classes.footer}>
          <AppButton
            className={classes.button}
            variant="contained"
            color="secondary"
            fullWidth
            size="large"
            type="submit"
            disabled={sending}
          >
            {t("signIn.buttonLabels.signIn")}
            {sending && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </AppButton>
          <ReverseAppButton
            variant="outlined"
            color="secondary"
            fullWidth
            size="large"
            component={Link}
            to="/app/"
          >
            {t("signIn.buttonLabels.cancel")}
          </ReverseAppButton>
        </Box>
      </form>
      <Snackbar
        open={error !== ""}
        autoHideDuration={6000}
        onClose={handleMessageClose}
      >
        <MobileAlert onClose={handleMessageClose} severity="error">
          {error}
        </MobileAlert>
      </Snackbar>
      <YesNoDialog
        title=""
        text={dailogueText}
        open={openDialog}
        onAnswer={handleDialogAnswer}
      />
    </MobileRegularPage>
  );
};

export default withRouter(SignIn);
